<template>
  <div class="admin-page admin-index-container">
    <div class="admin-index-box">
      <div class="logo">
        <img @click="$router.push('/')" src="@/assets/image/logo-color.png" height="36" alt="logo-icon"/>
      </div>
      <form @submit.prevent="submit" method="post">
        <input id="nameInput" type="text" maxlength="30" v-model="username" placeholder="아이디">
        <input type="password" maxlength="30" v-model="password" placeholder="비밀번호">
        <button class="vhp-button">관리자 로그인</button>

      </form>

      <a >문의 programming@vazilcompany.com</a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AdminIndex',
  data: () => {
    return {
      username: '',
      password: '',
    }
  },
  methods: {
    submit(){
      if(!this.username || !this.password){
        alert('아이디와 비밀번호를 입력하세요.')
        return
      }
      
      this.$axios.post('/auth', {
        username: this.username,
        password: this.password
      })
      .then((res)=>{
        if(res.data.accessToken){
          this.$store.commit('setFrontToken', this.$CryptoJS.AES.encrypt(process.env.VUE_APP_VALIDATION_TEXT, process.env.VUE_APP_SECRET_KEY).toString())
          this.$store.commit('setApiToken', `Bearer ${res.data.accessToken}`)
          this.$store.commit('setAdmin', {username: this.username})
          this.$axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.accessToken}`

          let route = this.$router.resolve({name: 'adminConsole'});
          window.open(route.href, '_self');
        }
      })
      .catch(err=>{
        console.log("LOGIN ERROR : " , err)
        window.alert('승인되지 않은 계정입니다.')
      })
    },
  },
  mounted() {
    document.querySelector('#nameInput').focus()

  },
}
</script>

<style lang="scss" src="./index.scss"></style>
